module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-default navbar-dark navbar-custom navbar-custom-dark bg-dark"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarCollapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav ml-auto navbar-center",
    attrs: {
      "id": "mySidenav"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link scroll",
    attrs: {
      "href": "#home"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.home')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link scroll",
    attrs: {
      "href": "#features"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.keyFacts')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.$t('lang')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$locale.change('fr')
      }
    }
  }, [_vm._v("FR")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$locale.change('en')
      }
    }
  }, [_vm._v("EN")])])])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "bg-dark footer-one"
  }, [_c('div', {
    staticClass: "footer-one-alt"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "m-b-0 font-13 copyright"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home.footer.terms')))])])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('cookie-law', {
    attrs: {
      "theme": "dark-lime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('div', {
          staticClass: "cookie-law__container"
        }, [_c('p', {
          staticClass: "cookie-law__details"
        }, [_vm._v(_vm._s(_vm.$t('cookie_law.message')))]), _vm._v(" "), _c('div', {
          staticClass: "cookie-law__actions"
        }, [_c('button', {
          staticClass: "cookie-law__action cookie-law__accept-btn",
          on: {
            "click": props.accept
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('cookie_law.accept')))])]), _vm._v(" "), _c('button', {
          staticClass: "cookie-law__action cookie-law__refuse-btn",
          on: {
            "click": props.close
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('cookie_law.refuse')))])])])])
      }
    }])
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand logo",
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/images/logo_white.png",
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarCollapse",
      "aria-controls": "navbarCollapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "m-b-0 font-13 copyright"
  }, [_vm._v("© 2019 Foxypark")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('ul', {
    staticClass: "list-inline footer-social-one m-b-0 float-right"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Foxypark",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "pe-so-facebook"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.instagram.com/foxypark_app",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "pe-so-instagram"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 33
// module chunks = 0